import { render } from "./BatchSetSystem.vue?vue&type=template&id=128729fa&ts=true"
import script from "./BatchSetSystem.vue?vue&type=script&lang=tsx"
export * from "./BatchSetSystem.vue?vue&type=script&lang=tsx"

import "./BatchSetSystem.vue?vue&type=style&index=0&id=128729fa&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__